<template>
  <div class="main-container">
    <template v-for="(block, index) in blocks" :key="block.id">
      <block :index="index" v-bind:block="block"></block>
    </template>
    <Preload v-if="loading"></Preload>
    <create-section-button v-if="adminIsEnabled && blocks.length < 1"></create-section-button>
    <create-block-button v-if="adminIsEnabled && blocks.length >= 1"></create-block-button>
  </div>
</template>

<script>
import Admin        from '@admin/mixins/_Admin'
import Random       from '@core/assets/js/utils/random'
import Lazyload     from '@core/assets/js/modules/lazyload'
import Preload      from '@app/templates/vuejs/components/_partials/Preload'
import _Page        from '@core/vuejs/templates/mixins/_Page'
import _SSRPath from "@core/vuejs/templates/mixins/_SSRPath.vue";

export default {
  name: "SectionPage",
  components: {Preload},
  mixins: [_Page, Admin, _SSRPath],
  data: function() {
    return {
      loading: false,
      blocksStorage: []
    };
  },
  async serverPrefetch () {
    let url = this.getCurrentPath() === '/' ? '/home' : this.getCurrentPath()
    await this.$store.dispatch("section/fetchPage", {url});
  },
  mounted() {
    let action = this.loadByScroll
    Lazyload.create('footer', action)
  },
  computed: {
    page: function () {
      return this.$store.getters["section/page"];
    },
    blocks: function () {
      return this.$store.getters["section/blocks"];
    },
    /**
     *
     * @returns {any[]|boolean}
     */
    next: function ()
    {
      if (!this.blocks) return false;
      let blocks = this.blocks.filter((block) => false === block.populated);
      if (!blocks || 0 === blocks.length) return false;
      let ids = new Array();
      let blockDefault = blocks.length // Esto viene por configuración
      blocks.splice(0, blockDefault || 4).forEach((block) => {
        return ids.push(block.id);
      });
      return ids;
    }
  },
  methods: {
    rnd: Random,
    loadByScroll: function ()
    {
      if (true === this.loading || false === this.next) return false

      this.loading = true
      let blocksString = this.next ? this.next.join(',') : ''

      let store = this.$store

      let section = window._page.internalName || 'home'
      let blocks = this.getBlocksStorage(section)
      if(blocks && blocks.length > 0 && blocks.filter(elem => this.next.indexOf(elem.id) > -1).length > 0){
        // si existen esos ids de bloque en el localstorage los recuperamos y almacenamos en el store
        blocks.forEach((block) => {
          store.commit("section/block", block)
        })
        this.loading = false
      }else{
        // no existen los ids de bloque, hacemos la peticion a la api
        this.$client.Get('/pages/' + this.page.id + '/blocks', {
          query: {
            blocks: blocksString,
            version: this.page.updated || this.rnd()
          },
          callback: (response) => {
            if (0 === response.length) return false
            response.block.forEach((block) => {
              store.commit("section/block", block)
              this.loading = false
            })
            let blocks = this.getBlocksStorage(section) || {}
            blocks = [...blocks, ...response.block] || []
            sessionStorage.setItem('blocks'+section, JSON.stringify(blocks))
          },
          progressbar: true
        })
      }
    },
    getBlocksStorage: function (section) {
      return JSON.parse(sessionStorage.getItem('blocks'+section)) || [];
    },
  },
  beforeMount ()
  {
    let store = this.$store
    let section = window._page.internalName || 'home'
    let version = JSON.parse(sessionStorage.getItem('version')) || {}
    version[section] = this.page.updated || false
    let versionStorage = JSON.parse(sessionStorage.getItem('version')) || false

    if ( version[section] === versionStorage[section] )
    {
      // si la version actual para la seccion es la misma que la guardada en el session storage, obtenemos los bloques guardados para esa seccion y los almacenamos en el store de vuejs
      this.blocksStorage = this.getBlocksStorage(section);
      if ( this.blocksStorage.length > 0 )
      {
        this.blocksStorage.forEach((block) => {
          store.commit("section/block", block)
        })
      }
    }else{
      // sino actualizamos la version y reiniciamos los bloques
      sessionStorage.setItem('version', JSON.stringify(version));
      sessionStorage.removeItem('blocks'+section);
    }
  }
}
</script>